import supportroomNameLogo from '../Assets/support-room-logo-light-final.png'
import supportroomIconLogo from '../Assets/supportroom-logo.svg'
import nixyNameLogo from '../Assets/nixy_sidebar-2.png'

import srTC from '../Assets/terms_conditions.docx';
import nixyTC from '../Assets/nixy_terms_conditions.docx';

const hostname = window.location.hostname?.toLowerCase();
const pathname = window.location.pathname?.toLowerCase();

console.log('hostname testing',hostname)

const supportroomConfig = {
    hostname: hostname,
    nameLogo: supportroomNameLogo,
    iconLogo: supportroomIconLogo,
    terms: srTC,
    sourcecompany:'supportroom'
}

const supportroomb2b2cConfig = {
    hostname: hostname,
    nameLogo: supportroomNameLogo,
    iconLogo: supportroomIconLogo,
    terms: srTC,
    sourcecompany:'supportroomb2b2c'
}

const nixyConfig = {
    hostname: hostname,
    nameLogo: nixyNameLogo,
    iconLogo: nixyNameLogo,
    terms: nixyTC,
    sourcecompany:'nixy'
}

export const isNixy = hostname.includes('nixy')
export const isB2B2C = hostname.includes('b2b2c') || pathname.includes('b2b2c');

const config = isNixy
    ? nixyConfig
    : 
    isB2B2C ? supportroomb2b2cConfig : supportroomConfig

// const config = supportroomb2b2cConfig;

export default config;